export default __webpack_public_path__ + "static/media/pinToChrome.694dfab5.gif";